import React from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { trackHubGoalsSet } from '@cvt/tracking';
import { FeedbackContext, LocalizationContext } from '@cvt/contexts';

import { cacheKeys } from '../config';
import { hubClient } from '../client/hubClient';


export const useHubProfile = () => {
  const { data: profile, isLoading, status, error } = useQuery({
    queryKey: [cacheKeys.getHubProfile],
    queryFn: hubClient.getProfile,
  });

  return { profile, isLoading, status, error };
};

export const usePrefetchHubProfile = (enabled: boolean) => {
  const queryClient = useQueryClient();

  React.useEffect(() => {
    if (!enabled) return;
    queryClient.prefetchQuery({
      queryKey: [cacheKeys.getHubProfile],
      queryFn: hubClient.getProfile,
    });
  }, [enabled, queryClient]);
};

export const useHubGoalsCrud = () => {
  const queryClient = useQueryClient();
  const { dictionary } = React.useContext(LocalizationContext);
  const { triggerFeedback } = React.useContext(FeedbackContext);

  const updateGoals = useMutation({
    mutationKey: [cacheKeys.updateHubGoals],
    mutationFn: (goals: Hub.Goals) => hubClient.updateGoals(goals),
    onSuccess: (profile, goals) => {
      queryClient.setQueryData([cacheKeys.getHubProfile], profile);
      triggerFeedback({ severity: 'success', message: dictionary.feedback.changesSaved });
      trackHubGoalsSet(goals.priorities.length);
    },
  });

  return { updateGoals };
};
